import axios from '@/axios'

const state = {
    postingFreeText: [],
    clientDocTypes: []
};

const getters = {
    getClientDocTypes: (state) => state.clientDocTypes,
    getClientPostingFreeText: (state) => state.postingFreeText
};

const mutations = {
    setClientDocTypes: (state, clientDocTypes) => (state.clientDocTypes = clientDocTypes),
    setClientPostingFreeText: (state, postingFreeText) => (state.postingFreeText = postingFreeText),
};

const actions = {
    async loadClientPostingFreeText(context, data) {
        await axios().get(`/getClientPostingFreeText`, {
            params: {
                client: data.client,
                page: data.page,
                per_page: data.per_page,
                date_from: data.date_from,
                date_to: data.date_to
            }
        }).then(response => {
            context.commit('setClientPostingFreeText', response.data.clientPostingFreeText)
            context.commit('setClientDocTypes', response.data.clientDocTypes)
            context.dispatch('handleResponse', response)
        })
    },
    async deleteClientPostingFreeText(context, data) {
        await axios().post(`/deleteClientPostingFreeText`, {
            itemId: data.itemId,
            userLevel: data.userLevel
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async updateClientPostingFreeText(context, data) {
        await axios().post(`/updateClientPostingFreeText`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async addClientPostingFreeText(context, data) {
        await axios().post(`/addClientPostingFreeText`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
